/** */
import { urls } from '../_url';
import { apiPost } from '../_http';

/** */
const base_url = `${urls.ai}/v1/text`;

export const checkSpaminess = async (options = {}) => {
  return await apiPost(`${base_url}/spaminess`, { ...options });
};
